import { ReactNode } from "react";

interface HorizontalScrollProps {
  children: ReactNode;
  alignment?: "start" | "center" | "end";
  gap?: string; // ej. "gap-4", "gap-6"
  paddingX?: string; // ej. "px-4", "px-6"
  className?: string; // clases extra opcionales
}

export function HorizontalScroll({
  children,
  alignment = "center",
  gap = "gap-6",
  paddingX = "px-6",
  className = "",
}: HorizontalScrollProps) {
  // Mapeamos la prop alignment a Tailwind justify-*
  const justifyClass = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
  }[alignment];

  return (
    <div className="overflow-x-auto scrollbar-hide">
      <div
        className={`inline-flex min-w-full ${justifyClass} ${gap} ${paddingX} ${className}`}
      >
        {children}
      </div>
    </div>
  );
}
